import { Link } from '@siemens/element-ng/link';
import { FooterConfig } from './footer-config.interface';

export const FOOTER_LINKS: Link[] = [
    {
        title: 'footer.links.corporateInformation',
        href: 'https://www.siemens.com/de/de/general/legal.html',
        target: '_blank'
    },
    { title: 'footer.links.privacyNotice', href: 'https://www.siemens.com/de/de/general/datenschutz.html' },
    { title: 'footer.links.cookieNotice', href: 'https://www.siemens.com/de/de/general/cookie-richtlinien.html' },
    { title: 'footer.links.termsOfUse', href: 'https://www.siemens.com/at/de/general/nutzungsbedingungen.html' },
    { title: 'footer.links.digitalId', href: 'https://www.siemens.com/global/en/general/digital-id.html' }
];

export const FOOTER_CONFIG: FooterConfig = {
    copyright: `© Siemens AG 1996 – ${new Date().getFullYear()}`,
    poweredBy: 'powered by /GMS/',
    poweredByHref: 'https://gms.siemens.cloud/',
    links: FOOTER_LINKS
};

export const FOOTER_COPYRIGHT_MANAGEMENT_PORTAL = 'Siemens AG ' + new Date().getFullYear();
